import { useState, useEffect } from 'react';
import { privacyPolicyData, termsAndConditions } from 'constants/mock';
import {
  isLoyaltyCardNumberValid,
  isCheckBoxChecked,
  isEmailIdValid
} from '../form-validations';

export const useForm = (showEmailIdField) => {
  const [cardNumber, setCardNumber] = useState('');
  const [emailId, setEmailId] = useState('');
  const [companyCode, setCompanyCode] = useState('');
  const [employeeId, setEmployeeId] = useState('');
  const [checkboxChecked, setCheckboxChecked] = useState(false);
  const [cardNumberError, setCardNumberError] = useState('');
  const [emailIDError, setEmailIdError] = useState('');
  const [companyCodeError, setCompanyCodeError] = useState('');
  const [employeeIdError, setEmployeeIdError] = useState('');
  const [checkboxError, setCheckboxError] = useState('');
  const [isFormValid, setIsFormValid] = useState(false);
  const [data, setData] = useState({
    heading: '',
    content: ''
  });

  const openTermsAndConditions = () => {
    setData({
      heading: 'Terms & conditions',
      content: termsAndConditions
    });
  };

  const openPrivacyPolicy = () => {
    setData({
      heading: 'Privacy policy',
      content: privacyPolicyData
    });
  };

  useEffect(() => {
    const isValidLoyaltyCardNumber = isLoyaltyCardNumberValid(cardNumber, setCardNumberError, false);
    const isValidCheckBox = isCheckBoxChecked(checkboxChecked, setCheckboxError, false);
    const isValidEmailId = showEmailIdField ? isEmailIdValid(emailId, setEmailIdError, false) : true;

    setIsFormValid(
      isValidLoyaltyCardNumber && isValidEmailId && isValidCheckBox
    );
  }, [cardNumber, emailId, companyCode, employeeId, checkboxChecked, showEmailIdField]);

  return {
    cardNumber,
    setCardNumber,
    emailId,
    setEmailId,
    companyCode,
    setCompanyCode,
    employeeId,
    setEmployeeId,
    checkboxChecked,
    setCheckboxChecked,
    emailIDError,
    setEmailIdError,
    cardNumberError,
    setCardNumberError,
    companyCodeError,
    setCompanyCodeError,
    employeeIdError,
    setEmployeeIdError,
    checkboxError,
    setCheckboxError,
    isFormValid,
    setIsFormValid,
    data,
    setData,
    openTermsAndConditions,
    openPrivacyPolicy
  };
};
